import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ProviderInvoiceRetentionModel } from 'src/app/models/shopping/provider-invoice-retention.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProviderInvoiceRetentionService {

  private readonly _httpClient = inject(HttpClient);

  createProviderInvoiceRetention(providerInvoiceRetention: ProviderInvoiceRetentionModel): Observable<ProviderInvoiceRetentionModel> {
    return this._httpClient.post<ProviderInvoiceRetentionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceRetention.CreateProviderInvoiceRetention}`,
      providerInvoiceRetention);
  }

  deleteProviderInvoiceRetention(providerInvoiceRetentionId: number): Observable<ProviderInvoiceRetentionModel> {
    const params = new HttpParams().set('providerInvoiceRetentionId', providerInvoiceRetentionId);
    return this._httpClient.delete<ProviderInvoiceRetentionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceRetention.DeleteProviderInvoiceRetention}`,
      { params: params }
    );
  }

  deleteSomeDetails(providerInvoiceRetentionIds: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceRetention.DeleteSomeDetailsAsync}`,
      providerInvoiceRetentionIds
    );
  }

  getAllTaxesForSelectAsync():Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceRetention.GetAllTaxesForSelectAsync}`);
  }

  getColumnsForProviderInvoiceRetentionAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceRetention.GetColumnsForProviderInvoiceRetentionAsync}`);
  }

  getProviderInvoiceRetentionById(providerInvoiceRetentionId: number): Observable<ProviderInvoiceRetentionModel> {
    const params = new HttpParams().set('providerInvoiceRetentionId', providerInvoiceRetentionId);
    return this._httpClient.get<ProviderInvoiceRetentionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceRetention.GetProviderInvoiceRetentionById}`,
      { params: params }
    );
  }

  getProviderInvoiceRetentionsByProviderInvoiceIdWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, providerInvoiceId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant)
      .set('providerInvoiceId', providerInvoiceId);
    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceRetention.GetProviderInvoiceRetentionsByProviderInvoiceIdWithPagination}`,
      { params: params }
    );
  }

  updateProviderInvoiceRetention(providerInvoiceRetention: ProviderInvoiceRetentionModel): Observable<ProviderInvoiceRetentionModel> {
    return this._httpClient.put<ProviderInvoiceRetentionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceRetention.UpdateProviderInvoiceRetention}`,
      providerInvoiceRetention);
  }
}
